import React from 'react';
import { Eye, Award, Clock, GraduationCap, BookOpen } from 'lucide-react';
const trustItems = [{
  icon: Eye,
  label: '360° Situational Awareness'
}, {
  icon: Award,
  label: 'Highest Quality of Service'
}, {
  icon: Clock,
  label: '24/7 Customer Support'
}, {
  icon: GraduationCap,
  label: 'Training & Consulting'
}, {
  icon: BookOpen,
  label: 'Course Development'
}];
export function TrustStrip() {
  return <section className="py-8 border-b border-brand-gray-800 bg-brand-gray-900/60" data-id="element-724">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-725">
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-4" data-id="element-726">
          {trustItems.map(item => <div key={item.label} className="flex items-center gap-2.5" data-id="element-727">
              <item.icon className="w-4 h-4 text-brand-teal flex-shrink-0" data-id="element-728" />
              <span className="text-xs font-semibold text-brand-gray-300 uppercase tracking-wider" data-id="element-729">
                {item.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}